export interface SuggestedPillType {
    email: string;
    id: number;
    name: string;
    text?: string;
    type?: string;
    value?: string;
}
